'use client';
import dynamic from 'next/dynamic';
import { HomeBannerImageWithBlur } from '@/types/home-banner-image';

const HomeHeroCarouselClient = dynamic(() => import('./home-hero-carousel.client'), {
  ssr: false,
});

export default function HomeHeroCarouselDynamicClient({
  images,
}: {
  images: HomeBannerImageWithBlur[];
}) {
  return <HomeHeroCarouselClient images={images} />;
}
